<template>
  <v-dialog
    v-model="value"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    class="dia"
    @keydown.esc="$emit('input', false)"
  >
    <ReceiptForm
      @onDismiss="dismiss"
      :receiptId="receiptId"
      v-if="value"
      :projectId="projectId"
      @onSaveSuccess="onSaveSuccess"
    />
  </v-dialog>
</template>
<script>
import ReceiptForm from "./ReceiptForm.component.vue";
export default {
  props: {
    value: Boolean,
    receiptId: String,
    projectId: String,
  },
  components: {
    ReceiptForm,
  },
  data() {
    return {
      dialog: false,
      notifications: false,
      sound: true,
      widgets: false,
    };
  },
  methods: {
    dismiss() {
      this.$emit("input", false);
    },
    onSaveSuccess(data) {
      this.$emit("onSaveSuccess", data);
    },
  },
};
</script>
<style lang="scss" scoped>
.card-receipt-form {
  height: calc(100vh - 110px);
  overflow-y: scroll;
  overflow-x: hidden;
}
</style>
